let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e8nkI")).then(() => parcelRequire('7hzaq'));